exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.container {\n  width: 60%;\n  height: 70%;\n  border-radius: 3px;\n  color: #212121;\n}\n\n.front, .back {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: white;\n\n  padding: 15px 30px;\n\n  border-radius:3px;\n}\n\n.back {\n  background:#aaa;\n}\n\n.title h2 {\n  text-transform:uppercase;\n  letter-spacing:2px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/image-modal/image-modal.component.css
// module id = 211
// module chunks = 1